var React = require('react');

function Check (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 12.5C0 5.87258 5.37258 0.5 12 0.5C18.6274 0.5 24 5.87258 24 12.5C24 19.1274 18.6274 24.5 12 24.5C5.37258 24.5 0 19.1274 0 12.5Z","fill":"#1BE3AD","fillOpacity":"0.15","key":0}),React.createElement("path",{"d":"M0.5 12.5C0.5 6.14873 5.64873 1 12 1C18.3513 1 23.5 6.14873 23.5 12.5C23.5 18.8513 18.3513 24 12 24C5.64873 24 0.5 18.8513 0.5 12.5Z","stroke":"#1BE3AD","strokeOpacity":"0.3","key":1}),React.createElement("path",{"d":"M17.3 7.8L9 16.1L6.7 13.8C6.3 13.4 5.7 13.4 5.3 13.8C4.9 14.2 4.9 14.8 5.3 15.2L8.3 18.2C8.5 18.4 8.7 18.5 9 18.5C9.3 18.5 9.5 18.4 9.7 18.2L18.7 9.2C19.1 8.8 19.1 8.2 18.7 7.8C18.3 7.4 17.7 7.4 17.3 7.8Z","fill":"#1BE3AD","key":2})]);
}

Check.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = Check;

Check.default = Check;
